import { windowatch } from '../../../scripts/lib/windowatch';

export default class Hotline {

  constructor ($el) {
    this.$el = $el;

    this.$hotlineButton = $el.querySelector('.hotline__button');
    this.$hotlineBox = $el.querySelector('.hotline__box');

    if (this.$hotlineButton) {
      this.$hotlineButton.addEventListener('click', this.onHotlineClick.bind(this));
      windowatch.addResizeListener(this.onWindowResize.bind(this));

      this.setBoxMaxWidth();
    }
  }

  onHotlineClick (event) {
    event.preventDefault();

    this.$hotlineBox.classList.toggle('hotline__box--visible');
  }

  onWindowResize () {
    this.setBoxMaxWidth();
  }

  setBoxMaxWidth () {
    let boxWidth = window.innerWidth - 48; // subtract container padding
    this.$hotlineBox.style.maxWidth = boxWidth.toString() + 'px';
  }
}
